import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { useTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./reworkProductForm.data.form";
import InputSelect from "../../../utils/InputSelect";
import Breadcrumb from "../../../utils/breadCrumbs";
import PATHS from "../../../../constants/paths";
import { useNavigate } from "react-router-dom";
import * as ReworkProductService from "../../../../services/reworkProductServices";

const NewReworkProductForm = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [entryPoints, setEntryPoints] = useState([]);
  const [outPoints, setOutPoints] = useState([]);

  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.reworkProduct.title"), path: PATHS.LIST_ORDERS },
    { label: t("forms.reworkProduct.new") },
  ];

  const { handleSubmit, varieties, edit, values } = props;

  const loadAvaliableLocations = async () => {
    const entries = await ReworkProductService.getAvaliableOutPoints("0");
    const outs = await ReworkProductService.getAvaliableOutPoints("1");

    setEntryPoints(entries);
    setOutPoints(outs);
  };

  useEffect(() => {
    loadAvaliableLocations();

    if (edit && props.initialValues?.origin) {
    }
  }, [edit, props.initialValues.origin]);

  useEffect(() => {
    if (values.varietyCode) {
      const selectedVariety = varieties.find((item) => item.code === values.varietyCode);
      if (selectedVariety && selectedVariety.varietyItemCodeProcessed !== values.varietyItemCodeProcessed) {
        props.setFieldValue("varietyItemCodeProcessed", selectedVariety.varietyItemCodeProcessed);
      }
    }
  }, [values.varietyCode, varieties]);

  const cancelAction = () => {
    navigate(PATHS.REWORK_PRODUCT_LIST);
  };

  const addSelectedOutPoints = (value) => {
    if (value) {
      const currentPoints = Array.isArray(values.outPoints)
        ? values.outPoints
        : [];
      if (!currentPoints.includes(value)) {
        const updatedPoints = [...currentPoints, value];
        props.setFieldValue("outPoints", updatedPoints);
        props.setFieldValue("selectedOutPoint", null);
      }
    }
  };

  const removeSelectedOutPoint = (removeUuid) => {
    const currentPoints = Array.isArray(values.outPoints)
      ? values.outPoints
      : [];
    const updatedPoints = currentPoints.filter((uuid) => uuid !== removeUuid);
    props.setFieldValue("outPoints", updatedPoints);
  };


  return (
    <>
      <div className="row justify-content-center mt-4 mt-md-5">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <h3 className="title">{t("forms.reworkProduct.new")}</h3>
        </div>
      </div>
      <Breadcrumb items={breads} />
      <div className="row justify-content-center  ">
        <div className="col-12 col-md-11">
          <form onSubmit={handleSubmit} autoComplete="off">
            <div className="row">
              <div className="col-12 col-md-4 mt-2">
                <Field
                  id="varietyCode"
                  name="varietyCode"
                  labelField={t("forms.reworkProduct.labels.variety")}
                  component={InputSelect}
                  optionLabel="label"
                  optionValue="code"
                  options={varieties.map((item) => ({
                    code: item.code,
                    varietyItemCodeProcessed: item.varietyItemCodeProcessed,
                    variety: item.variety,
                    label: t(item.variety),
                  }))}
                  classNamePrefix="dark"
                  mandatory
                />
              </div>

              <div className="col-12 col-md-4 mt-2">
                <Field
                  id="entryPoint"
                  name="entryPoint"
                  labelField={t("forms.reworkProduct.labels.entryPoint")}
                  component={InputSelect}
                  optionLabel="label"
                  optionValue="uuid"
                  options={entryPoints.map((item) => ({
                    ...item,
                    label: t(item.name),
                  }))}
                  // onChangeValue={(value) => onSelectOrigin(value)}
                  classNamePrefix="dark"
                  mandatory
                />
              </div>
              <div className="col-12 col-md-4 mt-2">
                <Field
                  id="selectedOutPoint"
                  name="selectedOutPoint"
                  labelField={t("forms.reworkProduct.labels.outPoints")}
                  component={InputSelect}
                  optionLabel="label"
                  optionValue="uuid"
                  options={outPoints.map((item) => ({
                    ...item,
                    label: t(item.name),
                  }))}
                  onChangeValue={(value) => addSelectedOutPoints(value)}
                  classNamePrefix="dark"
                  mandatory
                />
                <div className="col-12 mt-3">
                  <h6>{t("forms.reworkProduct.labels.outPointsSelected")}:</h6>
                  <ul className="list-unstyled">
                    {Array.isArray(values.outPoints) &&
                    values.outPoints.length > 0 ? (
                      values.outPoints.map((uuid) => {
                        const pointData = outPoints.find(
                          (p) => p.uuid === uuid,
                        );
                        return (
                          <li
                            key={uuid}
                            className="d-flex justify-content-between align-items-center p-2 mb-2 bg-light rounded"
                          >
                            <span>
                              {pointData ? t(pointData.name) : uuid}
                            </span>
                            <button
                              type="button"
                              onClick={() =>
                                removeSelectedOutPoint(uuid)
                              }
                              className="btn btn-sm btn-danger rounded-circle"
                              title={
                                t("forms.reworkProduct.buttons.remove") ||
                                "Eliminar"
                              }
                            >
                              ×
                            </button>
                          </li>
                        );
                      })
                    ) : (
                      <p className="text-muted small">
                        {t("forms.reworkProduct.labels.noOutPoints") ||
                          "No hay puntos de salida seleccionados"}
                      </p>
                    )}
                  </ul>
                </div>
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-10 col-sm-11 text-center mt-5 mb-5">
                <button
                  type="button"
                  onClick={() => cancelAction()}
                  className="btn btn-lg btn-secondary me-2"
                >
                  {t("forms.reworkProduct.buttons.cancel")}
                </button>
                <button type="submit" className="btn btn-lg btn-primary">
                  {t("forms.reworkProduct.buttons.save")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

NewReworkProductForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
};

const NewReworkProductFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: (props) => {
    return validationDataModel(props.edit);
  },
  handleSubmit: (values, { props, resetForm }) => {

    const cleanValues = {
      varietyCode: values.varietyCode,
      entryPoint: values.entryPoint,
      outPoints: values.outPoints,
      varietyItemCodeProcessed: values.varietyItemCodeProcessed,
    };
    props.onSubmit(cleanValues, resetForm);
  },
  enableReinitialize: true,
  displayName: "NewReworkProductForm",
})(NewReworkProductForm);

export default NewReworkProductFormF;
